import React, { useEffect } from 'react';
import './terms-of-service.styles.scss';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import { useSelector } from 'react-redux';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { Link } from 'react-router-dom';

const TermsOfService = () => {

  const screenSize = useSelector(state => state.contentData.screenSize);

  useEffect(() => {
    changeDocumentTitle('Terms of Service');
    let els = document.getElementsByClassName('layout-body');
    for (let el of els) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <UnauthLayout>
      <div className={`terms-container ${screenSize}`}>
          <div className='info-card g-card'>
            <div className='card-title'>
                Terms of Use and Service
            </div>
            <div className="g-space-1"></div>
            <div className='meta'>Last updated March 13, 2025</div>
            <hr />
            <div className='terms-content'>
              <h3>AGREEMENT TO OUR LEGAL TERMS</h3>
              <p>We are Gamably LLC (<b>"Company," "we," "us," "our," “Gamably”</b>), a company registered in Ohio, United States.
                You can contact us by email at charlie@gamably.com, or by mail to P.O. Box 66, Pickerington, OH 43147, United States.
              </p>
              <p>We operate the website located at <a href="https://app.gamably.com/">https://app.gamably.com/</a> and the website located at
                <a href="https://www.gamably.com/">https://www.gamably.com/</a> (collectively, the <b>"Site"</b>),
                as well as any other related products and services that refer or link to these legal terms (the <b>"Legal Terms"</b>)
                now or in the future (collectively, the <b>"Services"</b>).
                Visitors and users of the Services are referred to individually as <b>“User”</b> and <b>“Users"</b>.
                Additionally, school related visitors and users of the Services are referred to as <b>“School Users”</b> and the
                representatives of the school institution as the <b>“School Personnel”</b>.
                Use of the Services is governed by these Terms of Use and the Company <Link to="/privacy">Privacy Policy</Link>.
              </p>
              <p>
                These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity
                (<b>"you"</b> and <b>“your”</b>), and Gamably, LLC, concerning your access to and use of the Services. You agree that by
                accessing the Services, you expressly acknowledge that you have read, understood, and agreed to be bound by all of these
                Legal Terms and the Company <a href="https://app.gamably.com/privacy">Privacy Policy</a>.
                IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING
                THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
              </p>
              <p>
                If you are a registered User, we will provide you with prior notice of any scheduled changes to the Services you are using.
                The modified Legal Terms will become effective upon posting with an updated effective date or notifying you via
                charlie@gamably.com, as stated in the email message. By continuing to use the Services after the effective date of
                any changes, you agree to be bound by the modified terms.
              </p>
              <p>
                All Users who are minors in the jurisdiction in which they reside (generally under the age of 18)
                must have the permission of, and be directly supervised by, their parent or legal guardian
                (or, for School Users, by School Personnel as permitted under the terms) to use the Services.
                If you are a minor, you must have your parent, legal guardian, or School Personnel read and agree to
                these Legal Terms prior to you using the Services. If you are a School Personnel and are registering
                School Users, you agree, on behalf of your institution, that the School Users are bound by the Terms of Use herein. 
              </p>
              <h4>If you are a User, or School Personnel the following terms apply to you: </h4>
              <ul>
                <li>You must use the Services and Site in compliance with all applicable laws, rules, and regulations.
                  You are responsible for determining (and confirming) that your use of the Services is and the Site is
                  permitted by your institution and any applicable policies for your institution. 
                </li>
                <li>
                  You have a responsibility to obtain and receive any consent required to use our Services prior to using our Services. 
                </li>
                <li>
                  Your use of the Services is an agreement that you are familiar with applicable student privacy laws.
                </li>
                <li>
                  You assume responsibility for providing appropriate notices and disclosures to students using
                  the Services for classroom or school-wide use. 
                </li>
                <li>
                  You will immediately notify the Company if any consent is rescinded for any School Users
                  and the Company will remove the access of the named user/s.
                </li>
                <li>
                  Any use of integrated services used by School Users is permitted by your institution and consent
                  has been obtained by you or your institution for the use of the integrated service.
                </li>
              </ul>
              <p>
                We recommend that you print a copy of these Legal Terms for your records.
              </p>
              <h3>
                TABLE OF CONTENTS
              </h3>
              <ol>
                <li>
                  <a href='#os'>OUR SERVICES</a>
                </li>
                <li>
                  <a href='#ipr'>INTELLECTUAL PROPERTY RIGHTS</a>
                </li>
                <li>
                  <a href='#ur'>USER REPRESENTATIONS</a>
                </li>
                <li>
                  <a href='#ureg'>USER REGISTRATION</a>
                </li>
                <li>
                  <a href='#pp'>PURCHASES AND PAYMENT</a>
                </li>
                <li>
                  <a href='#sub'>SUBSCRIPTIONS</a>
                </li>
                <li>
                  <a href='#sw'>SOFTWARE</a>
                </li>
                <li>
                  <a href="#pa">PROHIBITED ACTIVITIES</a>
                </li>
                <li>
                  <a href="#ugc">USER GENERATED CONTRIBUTIONS</a>
                </li>
                <li>
                  <a href="#cb">CONTRIBUTION LICENSE</a>
                </li>
                <li>
                  <a href="#sm">SERVICES MANAGEMENT</a>
                </li>
                <li>
                  <a href="#ppolicy">PRIVACY POLICY</a>
                </li>
                <li>
                  <a href="#dmc">DIGITAL MILLENNIUM COPYRIGHT ACT (DMCA) NOTICE AND POLICY</a>
                </li>
                <li>
                  <a href="#t">TERM AND TERMINATION</a>
                </li>
                <li>
                  <a href="#mt">MODIFICATIONS AND INTERRUPTIONS</a>
                </li>
                <li>
                  <a href="#gl">GOVERNING LAW</a>
                </li>
                <li>
                  <a href="#dr">DISPUTE RESOLUTION</a>
                </li>
                <li>
                  <a href="#c">CORRECTIONS</a>
                </li>
                <li>
                  <a href="#d">DISCLAIMER</a>
                </li>
                <li>
                  <a href="#l">LIMITATIONS OF LIABILITY</a>
                </li>
                <li>
                  <a href="#i">INDEMNIFICATION</a>
                </li>
                <li>
                  <a href="#ud">USER DATA</a>
                </li>
                <li>
                  <a href="#is">INTEGRATED SERVICES</a>
                </li>
                <li>
                  <a href="#ec">ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</a>
                </li>
                <li>
                  <a href="#ca">CALIFORNIA USERS AND RESIDENTS</a>
                </li>
                <li>
                  <a href="#m">MISCELLANEOUS</a>
                </li>
                <li>
                  <a href="#cu">CONTACT US</a>
                </li>
              </ol>
              <h3 id='os'>1. OUR SERVICES</h3>
              <p>The information provided when using the Services is not intended for distribution to or use
                by any person or entity in any jurisdiction or country where such distribution or use would be
                contrary to law or regulation or which would subject us to any registration requirement within
                such jurisdiction or country. Accordingly, those persons who choose to access the Services from
                other locations do so on their own initiative and are solely responsible for compliance with
                local laws, if and to the extent local laws are applicable.
              </p>
              <p>
                When an account is created there are two options for account creators; players and managers.
                Information about each type of account and the access that each account has is briefly described below.
              </p>
              <p>
                Players: All users can be players. Players can submit content to managers, and use the manager
                created aspects of the Services. Players cannot message, post, or otherwise interact with other
                players in their games digitally through our Services.
              </p>
              <p>
                Managers: Can create games and add players to them. Can create content within the Services for
                Players to interact with, can post content which can be seen by players and other Managers in a game.
              </p>
              <p>
                We provide Services for free or via paid plans. To register for a Pro Plan, Premium Plan, or
                Enterprise Plan, you must make a payment. For payments and terms surrounding the process see
                section 5 and for information regarding the subscription see section 6. 
              </p>
              <h3 id='ipr'>2. INTELLECTUAL PROPERTY RIGHTS</h3>
              <h4>Our intellectual property</h4>
              <p>
                We are the owner or the licensee of all intellectual property rights in our Services,
                including all source code, databases, functionality, software, website designs, audio,
                video, text, photographs, and graphics in the Services (collectively, the "Content"),
                as well as the trademarks, service marks, and logos contained therein (the "Marks").
              </p>
              <p>
                Our Content and Marks are protected by copyright and trademark laws (and various other
                intellectual property rights and unfair competition laws) and treaties in the United
                States and around the world.
              </p>
              <p>
                The Content and Marks are provided in or through the Services "AS IS" for your personal,
                non-commercial use or internal business purpose only.
              </p>
              <h4>Your use of our Services</h4>
              <p>
                Subject to your compliance with these Legal Terms, including the "PROHIBITED ACTIVITIES"
                section below, we grant you a non-exclusive, non-transferable, revocable license to:
              </p>
              <ul>
                <li>
                  access the Services; and
                </li>
                <li>
                  download or print a copy of any portion of the Content to which you have properly
                  gained access solely for your personal, non-commercial use or internal business purpose.
                </li>
              </ul>
              <p>
                Except as set out in this section or elsewhere in our Legal Terms, no part of the Services
                and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted,
                publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise
                exploited for any commercial purpose whatsoever, without our express prior written permission.
              </p>
              <p>
                If you wish to make any use of the Services, Content, or Marks other than as set out in this
                section or elsewhere in our Legal Terms, please address your request to: charlie@gamably.com.
                If we ever grant you the permission to post, reproduce, or publicly display any part of our
                Services or Content, you must identify us as the owners or licensors of the Services, Content,
                or Marks and ensure that any copyright or proprietary notice appears or is visible on posting,
                reproducing, or displaying our Content.
              </p>
              <p>
                We reserve all rights not expressly granted to you in and to the Services, Content, and Marks.
              </p>
              <p>
                Any breach of these Intellectual Property Rights will constitute a material breach of our
                Legal Terms and your right to use our Services will terminate immediately.
              </p>
              <h4>Your submissions and contributions</h4>
              <p>
                Please review this section and the "PROHIBITED ACTIVITIES" section carefully prior to using
                our Services to understand the (a) rights you give us and (b) obligations you have when you post
                or upload any content through the Services.
              </p>
              <p>
                <b>Submissions:</b> By directly sending us any question, comment, suggestion, idea, feedback,
                or other information about the Services ("Submissions"), you agree to assign to us all intellectual
                property rights in such Submission. You agree that we shall own this Submission and be entitled to
                its unrestricted use and dissemination for any lawful purpose, commercial or otherwise, without
                acknowledgment or compensation to you.
              </p>
              <p>
                <b>Contributions (Part 1):</b> The Services may invite you, as a Player, to use functionality during
                which you may create, submit, post, display, transmit, publish, distribute, or broadcast content and
                materials to a Manager or us or through the Services, including but not limited to text, writings,
                video, audio, photographs, music, graphics, comments, reviews, rating suggestions, or other material
                ("Contributions"). 
              </p>
              <p>
                You understand that Contributions may be viewable by the Company and/or Managers within the game
                where contributions were submitted.
              </p>
              <p>
                <b>Contributions (Part 2):</b> The Services may invite you, as a Manager, to use functionality during
                which you may create, submit, post, display, transmit, publish, distribute, or broadcast content and
                materials to Players in your game or us or through the Services, including but not limited to text,
                writings, video, audio, photographs, music, graphics, comments, reviews, rating suggestions, or other
                material ("Contributions"). Any Submission that is publicly posted shall also be treated as a Contribution.
              </p>
              <p>
                You understand that Contributions may be viewable by the Company and/or Player Users in your game
                provided within the Services.
              </p>
              <p>
                <b>You are responsible for what you post or upload:</b> By sending us Submissions and/or posting&nbsp;
                Contributions through any part of the Services, you:
              </p>
              <ul>
                <li>
                  confirm that you have read and agree with our "PROHIBITED ACTIVITIES" and will not post, send,&nbsp;
                  publish, upload, or transmit through the Services any Submission nor post any Contribution that is&nbsp;
                  illegal, harassing, hateful, harmful, defamatory, obscene, bullying, abusive, discriminatory,&nbsp;
                  threatening to any person or group, sexually explicit, false, inaccurate, deceitful, or misleading;
                </li>
                <li>to the extent permissible by applicable law, waive any and all moral rights to any such Submission&nbsp;
                  and/or Contribution;
                </li>
                <li>
                  warrant that any such Submission and/or Contributions are original to you or that you have the&nbsp;
                  necessary rights and licenses to submit such Submissions and/or Contributions and that you have&nbsp;
                  full authority to grant us the above-mentioned rights in relation to your Submissions and/or&nbsp;
                  Contributions; and
                </li>
                <li>
                  warrant and represent that your Submissions and/or Contributions do not constitute confidential information.
                </li>
              </ul>
              <p>
                You are solely responsible for your Submissions and/or Contributions and you expressly agree to&nbsp;
                reimburse us for any and all losses that we may suffer because of your breach of (a) this section,&nbsp;
                (b) any third party’s intellectual property rights, or (c) applicable law.
              </p>
              <p>
                <b>We may remove or edit your Content:</b> Although we have no obligation to monitor any Contributions,&nbsp;
                we shall have the right to remove or edit any Contributions at any time without notice if in our&nbsp;
                reasonable opinion we consider such Contributions harmful or in breach of these Legal Terms. If we&nbsp;
                remove or edit any such Contributions, we may also suspend or disable your account and report you to&nbsp;
                the authorities.
              </p>
              <h4>Third Party Graphic Attribution</h4>
              <p>The following third-party graphics are used in the Services:</p>
              <ul>
                <li><a href="https://www.flaticon.com/free-icons/credit-card" title="credit card icons">Credit card icons created by Magnific - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/packs/medals-and-rewards" title="medals and rewards icons">Medals and Rewards icons created by Vectors Market - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/free-icons/mountain" title="mountain icons">Mountain icons created by Magnific - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/packs/game-elements-5" title="game elements icons">Game Elements icons created by Smashicons - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/packs/game-elements-12" title="game elements icons">Game Elements icons created by surang - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/packs/rank-badge" title="rank icons">Rank icons created by Dimitry Miroliubov - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/packs/landscapes-collection" title="landscapes icons">Landscapes icons created by Magnific - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/free-icons/person" title="person icons">Person icons created by Magnific - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/free-icons/tour" title="tour icons">Tour icons created by Magnific - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/free-icons/mystery" title="mystery icons">Mystery icons created by imaginationlol - Flaticon</a></li>
                <li><a href="https://www.flaticon.com/free-icons/secret" title="secret icons">Secret icons created by Magnific - Flaticon</a></li>
              </ul>
              <h4>Copyright infringement</h4>
              <p>
                We respect the intellectual property rights of others. If you believe that any material available on&nbsp;
                or through the Services infringes upon any copyright you own or control, please immediately refer to&nbsp;
                the "DIGITAL MILLENNIUM COPYRIGHT ACT (DMCA) NOTICE AND POLICY" section below.
              </p>
              <h3 id='ur'>3. USER REPRESENTATIONS</h3>
              <p>
                By using the Services, you represent and warrant that: (1) all registration information you submit will&nbsp;
                be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and&nbsp;
                promptly update such registration information as necessary; (3) you have the legal capacity and you&nbsp;
                agree to comply with these Legal Terms; (4) you are not a minor in the jurisdiction in which you reside,&nbsp;
                or if a minor, you have received parental permission to use the Services; (5) you will not access the&nbsp;
                Services through automated or non-human means, whether through a bot, script or otherwise; (6) you will&nbsp;
                not use the Services for any illegal or unauthorized purpose; and (7) your use of the Services will not&nbsp;
                violate any applicable law or regulation.
              </p>
              <p>
                If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right&nbsp;
                to suspend or terminate your account and refuse any and all current or future use of the Services&nbsp;
                (or any portion thereof).
              </p>
              <h3 id='ureg'>4. USER REGISTRATION</h3>
              <p>
                You may be required to register to use the Services. You agree to keep your password confidential and&nbsp;
                will be responsible for all use of your account and password. We reserve the right to remove, reclaim,&nbsp;
                or change a username you select if we determine, in our sole discretion, that such username is inappropriate,&nbsp;
                obscene, or otherwise objectionable.
              </p>
              <h3 id='pp'>5. PURCHASES AND PAYMENT</h3>
              <p>
                Payment processing services for Users on Gamably are provided by Stripe and are subject to the&nbsp;
                <a href="https://stripe.com/connect-account/legal/full" target="_blank">Stripe Connected Account Agreement</a>,&nbsp;
                which includes the <a href="https://stripe.com/legal" target="_blank">Stripe Terms of Service</a>&nbsp;
                (collectively, the “Stripe Services&nbsp;
                Agreement”). By agreeing to these terms or continuing to operate as a User on Gamably, you agree to be bound&nbsp;
                by the Stripe Services Agreement, as the same may be modified by Stripe from time to time. As a condition of&nbsp;
                the Company enabling payment processing services through Stripe, you agree to provide the Company accurate and&nbsp;
                complete information about you and your business, and you authorize the Company to share it and transaction&nbsp;
                information related to your use of the payment processing services provided by Stripe.
              </p>
              <h3 id='sub'>6. SUBSCRIPTIONS</h3>
              <h4>Billing and Renewal</h4>
              <p>
                If you are on a Pro Plan, Premium Plan, or Enterprise Plan, your subscription will continue and automatically&nbsp;
                renew unless canceled. You consent to our charging your payment method on a recurring basis without requiring&nbsp;
                your prior approval for each recurring charge, until such time as you cancel the applicable order. The length&nbsp;
                of your billing cycle will depend on the type of subscription plan you choose when you subscribed to the Services.
              </p>
              <h4>Cancellation</h4>
              <p>
                All purchases are non-refundable. You can cancel your subscription at any time by logging into your account.&nbsp;
                Your cancellation will take effect at the end of the current paid term. If you have any questions or are&nbsp;
                unsatisfied with our Services, please email us at <a href="mailto:charlie@gamably.com" target="_blank">charlie@gamably.com</a>.
              </p>
              <h4>Fee Changes</h4>
              <p>
                We may, from time to time, make changes to the subscription fee and will communicate any price changes to you in&nbsp;
                accordance with applicable law.
              </p>
              <h3 id='sw'>7. SOFTWARE</h3>
              <p>
                We may include software for use in connection with our Services. If such software is accompanied by an end user&nbsp;
                license agreement ("EULA"), the terms of the EULA will govern your use of the software. If such software is not&nbsp;
                accompanied by a EULA, then we grant to you a non-exclusive, revocable, personal, and non-transferable license to&nbsp;
                use such software solely in connection with our services and in accordance with these Legal Terms. Any software and&nbsp;
                any related documentation is provided "AS IS" without warranty of any kind, either express or implied, including,&nbsp;
                without limitation, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.&nbsp;
                You accept any and all risk arising out of use or performance of any software. You may not reproduce or redistribute&nbsp;
                any software except in accordance with the EULA or these Legal Terms.
              </p>
              <h3 id='pa'>8. PROHIBITED ACTIVITIES</h3>
              <p>
                You may not access or use the Services for any purpose other than that for which we make the Services available.&nbsp;
                The Services may not be used in connection with any commercial endeavors except those that are specifically&nbsp;
                endorsed or approved by us.
              </p>
              <p>
                As a User, School User, or School Personnel using the Services, you agree not to:
              </p>
              <ul>
                <li>
                  Systematically retrieve data or other content from the Services to create or compile, directly or indirectly,&nbsp;
                  a collection, compilation, database, or directory without written permission from us.
                </li>
                <li>
                  Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information&nbsp;
                  such as user passwords.
                </li>
                <li>
                  Circumvent, disable, or otherwise interfere with security-related features of the Services, including features&nbsp;
                  that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Services&nbsp;
                  and/or the Content contained therein.
                </li>
                <li>
                  Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Services.
                </li>
                <li>
                  Use any information obtained from the Services in order to harass, abuse, or harm another person.
                </li>
                <li>
                  Make improper use of our support services or submit false reports of abuse or misconduct.
                </li>
                <li>
                  Use the Services in a manner inconsistent with any applicable laws or regulations.
                </li>
                <li>
                  Engage in unauthorized framing of or linking to the Services.
                </li>
                <li>
                  Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including&nbsp;
                  excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any&nbsp;
                  party’s uninterrupted use and enjoyment of the Services or modifies, impairs, disrupts, alters, or interferes&nbsp;
                  with the use, features, functions, operation, or maintenance of the Services.
                </li>
                <li>
                  Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data&nbsp;
                  mining, robots, or similar data gathering and extraction tools.
                </li>
                <li>
                  Delete the copyright or other proprietary rights notice from any Content.
                </li>
                <li>
                  Attempt to impersonate another user or person or use the username of another user.
                </li>
                <li>
                  Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information&nbsp;
                  collection or transmission mechanism, including without limitation, clear graphics interchange formats ("gifs"),&nbsp;
                  1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as "spyware" or "passive collection&nbsp;
                  mechanisms" or "pcms").
                </li>
                <li>
                  Interfere with, disrupt, or create an undue burden on the Services or the networks or services connected to the Services.
                </li>
                <li>
                  Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Services to you.
                </li>
                <li>
                  Attempt to bypass any measures of the Services designed to prevent or restrict access to the Services, or any&nbsp;
                  portion of the Services.
                </li>
                <li>
                  Copy or adapt the Services' software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.
                </li>
                <li>
                  Except as permitted by applicable law, decipher, decompile, disassemble, or reverse engineer any of the software comprising&nbsp;
                  or in any way making up a part of the Services.
                </li>
                <li>
                  Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any&nbsp;
                  automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses&nbsp;
                  the Services, or use or launch any unauthorized script or other software.
                </li>
                <li>
                  Use a buying agent or purchasing agent to make purchases on the Services.
                </li>
                <li>
                  Make any unauthorized use of the Services, including collecting usernames and/or email addresses of users by electronic or&nbsp;
                  other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.
                </li>
                <li>
                  Use the Services as part of any effort to compete with us or otherwise use the Services and/or the Content for any&nbsp;
                  revenue-generating endeavor or commercial enterprise.
                </li>
                <li>
                  Use the Services to advertise or offer to sell goods and services.
                </li>
                <li>
                  Sell or otherwise transfer your profile.
                </li>
              </ul>
              <h3 id='ugc'>9. USER GENERATED CONTRIBUTIONS</h3>
              <p>
                The Services may invite you to use functionality, that may provide you with the opportunity to create, submit, post, display,&nbsp;
                transmit, perform, publish, distribute, or broadcast content and materials to us or to Managers on the Services, including but&nbsp;
                not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other&nbsp;
                material (collectively, "Contributions"). Contributions may be viewable by other Users of the Services. As such, any Contributions&nbsp;
                you transmit may be treated as non-confidential and non-proprietary. When you create or make available any Contributions,&nbsp;
                you thereby represent and warrant that:
              </p>
              <ul>
                <li>
                  The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your&nbsp;
                  Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark,&nbsp;
                  trade secret, or moral rights of any third party.
                </li>
                <li>
                  You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize&nbsp;
                  us, the Services, and other users of the Services to use your Contributions in any manner contemplated by the Services and these Legal Terms.
                </li>
                <li>
                  You have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions&nbsp;
                  to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your Contributions&nbsp;
                  in any manner contemplated by the Services and these Legal Terms.
                </li>
                <li>
                  Your Contributions are not false, inaccurate, or misleading. 
                </li>
                <li>
                  Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass&nbsp;
                  mailings, or other forms of solicitation.
                </li>
                <li>
                  Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable&nbsp;
                  (as determined by us).
                </li>
                <li>
                  Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.
                </li>
                <li>
                  Your Contributions are not used to harass or threaten (in the legal sense of those terms) any other person and to promote violence&nbsp;
                  against a specific person or class of people.
                </li>
                <li>
                  Your Contributions do not violate any applicable law, regulation, or rule.
                </li>
                <li>
                  Your Contributions do not violate the privacy or publicity rights of any third party.
                </li>
                <li>
                  Your Contributions do not violate any applicable law concerning child pornography, or otherwise intended to protect the health or&nbsp;
                  well-being of minors.
                </li>
                <li>
                  Your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference,&nbsp;
                  or physical handicap.
                </li>
                <li>
                  Your Contributions do not otherwise violate, or link to material that violates, any provision of these Legal Terms, or any applicable law&nbsp;
                  or regulation.
                </li>
              </ul>
              <p>
                Any use of the Services in violation of the foregoing violates these Legal Terms and may result in, among other things, termination or&nbsp;
                suspension of your rights to use the Services.
              </p>
              <h3 id='cb'>10. CONTRIBUTION LICENSE</h3>
              <p>
                We do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and any intellectual&nbsp;
                property rights or other proprietary rights associated with your Contributions. We are not liable for any statements or representations&nbsp;
                in your Contributions provided by you in any area on the Services. You are solely responsible for your Contributions to the Services and&nbsp;
                you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions.
              </p>
              <p>
                We have the right, in our sole and absolute discretion, (1) to edit, redact, or otherwise change any Contributions; (2) to re-categorize any&nbsp;
                Contributions to place them in more appropriate locations on the Services; and (3) to pre-screen or delete any Contributions at any time and&nbsp;
                for any reason, without notice. We have no obligation to monitor your Contributions.
              </p>

              <h3 id='sm'>11. SERVICES MANAGEMENT</h3>
              <p>
                We reserve the right, but not the obligation, to: (1) monitor the Services for violations of these Legal Terms; (2) take appropriate legal 
                action against anyone who, in our sole discretion, violates the law or these Legal Terms, including without limitation, reporting such user 
                to law enforcement authorities; (3) in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, 
                or disable (to the extent technologically feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and 
                without limitation, notice, or liability, to remove from the Services or otherwise disable all files and content that are excessive in 
                size or are in any way burdensome to our systems; and (5) otherwise manage the Services in a manner designed to protect our rights and 
                property and to facilitate the proper functioning of the Services.
              </p>
              <h3 id='ppolicy'>12. PRIVACY POLICY</h3>
              <p>
                We care about data privacy and security. Please review our <Link to="/privacy">Privacy Policy</Link>. By using the Services, you 
                agree to be bound by our Privacy Policy, which is incorporated into these Legal Terms. Please be advised the Services are hosted in the 
                United States. If you access the Services from any other region of the world with laws or other requirements governing personal data 
                collection, use, or disclosure that differ from applicable laws in the United States, then through your continued use of the Services, 
                you are transferring your data to the United States, and you expressly consent to have your data transferred to and processed in the 
                United States.
              </p>
              <p>
                When you provide personal data in connection with payments to the Company, Stripe receives that personal data and processes it in 
                accordance with <a href="https://stripe.com/privacy" target="_blank">Stripe’s Privacy Policy</a>.
              </p>
              <h3 id='dpa'>13. DIGITAL MILLENNIUM COPYRIGHT ACT (DMCA) NOTICE AND POLICY</h3>
              <h4>Notifications</h4>
              <p>
                We respect the intellectual property rights of others. If you believe that any material available on or through the Services 
                infringes upon any copyright you own or control, please immediately notify our Designated Copyright Agent using the contact 
                information provided below (a "Notification"). A copy of your Notification will be sent to the person who posted or stored 
                the material addressed in the Notification. Please be advised that pursuant to federal law you may be held liable for damages 
                if you make material misrepresentations in a Notification. Thus, if you are not sure that material located on or linked to 
                by the Services infringes your copyright, you should consider first contacting an attorney.
              </p>
              <p>
                All Notifications should meet the requirements of DMCA 17 U.S.C. § 512(c)(3) and include the following information: 
                (1) A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is 
                allegedly infringed; (2) identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted 
                works on the Services are covered by the Notification, a representative list of such works on the Services; 
                (3) identification of the material that is claimed to be infringing or to be the subject of infringing activity 
                and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit 
                us to locate the material; (4) information reasonably sufficient to permit us to contact the complaining party, 
                such as an address, telephone number, and, if available, an email address at which the complaining party may be 
                contacted; (5) a statement that the complaining party has a good faith belief that use of the material in the 
                manner complained of is not authorized by the copyright owner, its agent, or the law; and (6) a statement that the 
                information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized 
                to act on behalf of the owner of an exclusive right that is allegedly infringed upon.
              </p>
              <h4>Counter Notification</h4>
              <p>
                If you believe your own copyrighted material has been removed from the Services as a result of a mistake or misidentification, 
                you may submit a written counter notification to [us/our Designated Copyright Agent] using the contact information provided below 
                (a "Counter Notification"). To be an effective Counter Notification under the DMCA, your Counter Notification must include 
                substantially the following: (1) identification of the material that has been removed or disabled and the location at which 
                the material appeared before it was removed or disabled; (2) a statement that you consent to the jurisdiction of the Federal 
                District Court in which your address is located, or if your address is outside the United States, for any judicial district 
                in which we are located; (3) a statement that you will accept service of process from the party that filed the Notification 
                or the party's agent; (4) your name, address, and telephone number; (5) a statement under penalty of perjury that you have a 
                good faith belief that the material in question was removed or disabled as a result of a mistake or misidentification of the 
                material to be removed or disabled; and (6) your physical or electronic signature.
              </p>
              <p>
                If you send us a valid, written Counter Notification meeting the requirements described above, we will restore your removed 
                or disabled material, unless we first receive notice from the party filing the Notification informing us that such party has 
                filed a court action to restrain you from engaging in infringing activity related to the material in question. Please note that 
                if you materially misrepresent that the disabled or removed content was removed by mistake or misidentification, you may be 
                liable for damages, including costs and attorney's fees. Filing a false Counter Notification constitutes perjury.
              </p>
              <h4>Designated Copyright Agent</h4>
              <p>
                Stuart Brinn<br />
                Attn: Copyright Agent<br />
                5090 Greens Dr<br />
                Lady Lakes, FL 32159<br />
                United States<br />
                stewart.brinn@gmail.com
              </p>
              <h3 id='t'>14. TERM AND TERMINATION</h3>
              <p>
                These Legal Terms shall remain in full force and effect while you use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF 
                THESE LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE 
                OF THE SERVICES (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT 
                LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE LEGAL TERMS OR OF ANY APPLICABLE LAW 
                OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR ACCOUNT AND ANY CONTENT OR 
                INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.
              </p>
              <p>
                If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under 
                your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party. 
                In addition to terminating or suspending your account, we reserve the right to take appropriate legal action, including 
                without limitation pursuing civil, criminal, and injunctive redress. 
              </p>
              <h3 id='mt'>15. MODIFICATIONS AND INTERRUPTIONS</h3>
              <p>
                We reserve the right to change, modify, or remove the contents of the Services at any time or for any reason at our sole 
                discretion without notice. However, we have no obligation to update any information on our Services. We will not be liable 
                to you or any third party for any modification, price change, suspension, or discontinuance of the Services.
              </p>
              <p>
                We cannot guarantee the Services will be available at all times. We may experience hardware, software, or other problems 
                or need to perform maintenance related to the Services, resulting in interruptions, delays, or errors. We reserve the 
                right to change, revise, update, suspend, discontinue, or otherwise modify the Services at any time or for any reason 
                without notice to you. You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by 
                your inability to access or use the Services during any downtime or discontinuance of the Services. Nothing in these 
                Legal Terms will be construed to obligate us to maintain and support the Services or to supply any corrections, updates, 
                or releases in connection therewith.
              </p>
              <h3 id='gl'>16. GOVERNING LAW</h3>
              <p>
                These Legal Terms and your use of the Services are governed by and construed in accordance with the laws of the State of 
                Ohio applicable to agreements made and to be entirely performed within the State of Ohio, without regard to its conflict 
                of law principles.
              </p>
              <h3 id='dr'>17. DISPUTE RESOLUTION</h3>
              <h4>Binding Arbitration</h4>
              <p>
                If the Parties are unable to resolve a Dispute through informal negotiations, the Dispute (except those Disputes expressly 
                excluded below) will be finally and exclusively resolved by binding arbitration. YOU UNDERSTAND THAT WITHOUT THIS 
                PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration shall be commenced and 
                conducted under the Commercial Arbitration Rules of the American Arbitration Association ("AAA") and, where appropriate, 
                the AAA’s Supplementary Procedures for Consumer Related Disputes ("AAA Consumer Rules"), both of which are available at 
                the <a href="http://www.adr.org/" target="_blank">American Arbitration Association (AAA) website</a>. Your arbitration fees and your share of arbitrator compensation shall 
                be governed by the AAA Consumer Rules and, where appropriate, limited by the AAA Consumer Rules. The arbitration may be 
                conducted in person, through the submission of documents, by phone, or online. The arbitrator will make a decision in 
                writing, but need not provide a statement of reasons unless requested by either Party. The arbitrator must follow 
                applicable law, and any award may be challenged if the arbitrator fails to do so. Except where otherwise required by the 
                applicable AAA rules or applicable law, the arbitration will take place in Fairfield County, Ohio. Except as otherwise 
                provided herein, the Parties may litigate in court to compel arbitration, stay proceedings pending arbitration, or to 
                confirm, modify, vacate, or enter judgment on the award entered by the arbitrator.
              </p>
              <p>
                If for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be commenced or prosecuted in the 
                state and federal courts located in Fairfield County, Ohio, and the Parties hereby consent to, and waive all defenses of 
                lack of personal jurisdiction, and forum non conveniens with respect to venue and jurisdiction in such state and federal 
                courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer 
                Information Transaction Act (UCITA) are excluded from these Legal Terms.
              </p>
              <p>
                In no event shall any Dispute brought by either Party related in any way to the Services be commenced more than one (1) 
                years after the cause of action arose. If this provision is found to be illegal or unenforceable, then neither Party will 
                elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and 
                such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, 
                and the Parties agree to submit to the personal jurisdiction of that court.
              </p>
              <h4>Restrictions</h4>
              <p>
                The Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full extent 
                permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or authority for any 
                Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c) there is no right or 
                authority for any Dispute to be brought in a purported representative capacity on behalf of the general public or any other persons.
              </p>
              <h4>Exceptions of Arbitration</h4>
              <p>
                The Parties agree that the following Disputes are not subject to the above provisions concerning binding arbitration: 
                (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual property rights 
                of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or 
                unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, 
                then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be 
                illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts 
                listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.
              </p>
              <h3 id='c'>18. CORRECTIONS</h3>
              <p>
                There may be information on the Services that contains typographical errors, inaccuracies, or omissions, including 
                descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, 
                inaccuracies, or omissions and to change or update the information on the Services at any time, without prior notice.
              </p>
              <h3 id='d'>19. DISCLAIMER</h3>
              <p>
                THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR 
                SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH 
                THE SERVICES AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS 
                FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR 
                COMPLETENESS OF THE SERVICES' CONTENT OR THE CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE SERVICES 
                AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND 
                MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF 
                THE SERVICES, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION 
                AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICES, 
                (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD 
                PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED 
                AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SERVICES. WE DO NOT 
                WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD 
                PARTY THROUGH THE SERVICES, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR 
                OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN 
                YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY 
                MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
              </p>
              <h3 id='l'>20. LIMITATIONS OF LIABILITY</h3>
              <p>
                IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, 
                CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, 
                OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. 
                NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS 
                OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE LESSER OF THE AMOUNT PAID, IF ANY, BY YOU TO US DURING 
                THE six (6) MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING OR $1,000.00 USD. CERTAIN US STATE LAWS AND INTERNATIONAL 
                LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS 
                APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.
              </p>
              <h3 id='i'>21. INDEMNIFICATION</h3>
              <p>
                You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective 
                officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including 
                reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: (1) your Contributions; (2) 
                use of the Services; (3) breach of these Legal Terms; (4) any breach of your representations and warranties set 
                forth in these Legal Terms; (5) your violation of the rights of a third party, including but not limited to intellectual 
                property rights; or (6) any overt harmful act toward any other user of the Services with whom you connected via the 
                Services. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and 
                control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with 
                our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding 
                which is subject to this indemnification upon becoming aware of it.
              </p>
              <h3 id='ud'>22. USER DATA</h3>
              <p>
                Read about our Data practices on our <Link to="/privacy">Privacy Policy</Link> webpage.
              </p>
              <h3 id="i">23. INTEGRATED SERVICES</h3>
              <p>
                The Services may contain links to third-party websites or services (“Integrated service(s)”) not owned or controlled 
                by the Company, or our Services may be accessed by logging in through an Integrated service (e.g. Google). 
                The inclusion of Integrated services does not imply affiliation or endorsement of such services by the Company. 
                The Company does not control these Third-Parties or their services and therefore when you access or use their services, 
                you do so at your own risk and agree without limitation that the Company is not responsible for such Integrated services. 
                You represent and warrant you have read and agree to be bound by all applicable policies, in addition to your 
                obligations under this Agreement. The Company has no control over, and assumes no responsibility for, the content, 
                accuracy, privacy policies, or practices of or opinions expressed in any Integrated service or by any third party. 
                In addition, the Company will not and cannot monitor, verify, censor or edit the content of any third party or their 
                service(s). By using Gamably’s Services, you expressly relieve and hold us harmless from any and all liability 
                arising from your use of any Integrated service(s).
              </p>
              <p>
                Your interactions with organizations and/or individuals found on or through the Services, including payment and 
                delivery of goods or services, and any other terms, conditions, warranties or representations associated with 
                such dealings, are solely between you and such organizations and/or individuals. You should make whatever investigation 
                you feel necessary or appropriate before proceeding with any online or offline transaction with any of these third 
                parties. You agree the Company shall not be responsible or liable for any loss or damage incurred as the result of 
                any such dealings. If there is a dispute between participants on any part of the Services subject to this Agreement, 
                or between Users and any third party, you understand and agree the Company has no interest therein and is under no 
                obligation to become involved. 
              </p>
              <h3 id="ec">24. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</h3>
              <p>
                Visiting the Services, sending us emails, and completing online forms constitute electronic communications. 
                You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, 
                and other communications we provide to you electronically, via email and on the Services, satisfy any legal 
                requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, 
                CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS 
                INITIATED OR COMPLETED BY US OR VIA THE SERVICES. You hereby waive any rights or requirements under any statutes, 
                regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery 
                or retention of non-electronic records, or to payments or the granting of credits by any means other than 
                electronic means.
              </p>
              <h3 id="#ca">25. CALIFORNIA USERS AND RESIDENTS</h3>
              <p>
                If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the 
                Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market 
                Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.
              </p>
              <h3 id='m'>26. MISCELLANEOUS</h3>
              <p>
                These Legal Terms and any policies or operating rules posted by us on the Services or in respect to the Services 
                constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any 
                right or provision of these Legal Terms shall not operate as a waiver of such right or provision. These Legal 
                Terms operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations 
                to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act 
                caused by any cause beyond our reasonable control. If any provision or part of a provision of these Legal Terms 
                is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed 
                severable from these Legal Terms and does not affect the validity and enforceability of any remaining provisions. 
                There is no joint venture, partnership, employment or agency relationship created between you and us as a 
                result of these Legal Terms or use of the Services. You agree that these Legal Terms will not be construed 
                against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the 
                electronic form of these Legal Terms and the lack of signing by the parties hereto to execute these Legal Terms.
              </p>
              <h3 id='cu'>27. CONTACT US</h3>
              <p>
                In order to resolve a complaint regarding the Services or to receive further information regarding use of the 
                Services, please contact us at:
              </p>
              <p>
                Gamably, LLC<br />
                P.O. Box 66<br />
                Pickerington, OH 43147<br />
                United States<br />
                Phone: 614-383-8373<br />
                charlie@gamably.com
              </p>
            </div>
          </div>
      </div>
    </UnauthLayout>
  )
}

export default TermsOfService;